import { useLayoutEffect } from "react";
import { useQuery } from "react-query";
import { usePictureTopUpStore } from "../store";
import { BindActivityInfo } from "@/components/top-up/types";

export function useFetchActivityInfoList() {
  const { setter } = usePictureTopUpStore();
  const { data, refetch } = useQuery<BindActivityInfo[]>(
    "/api/rendering/user/activity/template/getSupportActivity",
    { refetchOnWindowFocus: true }
  );

  useLayoutEffect(() => {
    if (!data) {
      setter((state) => {
        state.activityInfoList = [];
      });
      return;
    }
    setter((state) => {
      state.activityInfoList = data;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return {
    activityInfoListRefetch: refetch,
  };
}
